import React from "react";
import { css } from "@emotion/react";
import { Box } from "reflexbox";
import { CustomizerContext } from "./CustomizerContext";
import { AttributeControl } from "./AttributeControl";
import { PresetGroup } from "./PresetGroup";

export function ControlGroup({ name, presetsRender, defaultOpen }) {
	let { AttributesState, updateAttributes, presets, SelectedPresetsState } =
		React.useContext(CustomizerContext);
	let [attributes, setAttributes] = AttributesState;

	let id = `collapse-${name}`;

	let groupPresets = presets.filter((p) => p.type === name);

	return (
		<div className="card">
			<Box
				css={css`
					background-color: #fafafa;
				`}
			>
				<button
					className="btn btn-link btn-block text-left"
					type="button"
					data-toggle="collapse"
					data-target={`#${id}`}
					aria-expanded="true"
					aria-controls={id}
				>
					{name}
				</button>
			</Box>
			<div
				id={id}
				className={defaultOpen ? "collapse show" : "collapse"}
				aria-labelledby="headingOne"
				data-parent="#controls"
			>
				<Box pb={name === "Style" && 250} className="card-body">
					{groupPresets.length > 0 && (
						<PresetGroup
							presets={groupPresets}
							SelectedPresetsState={SelectedPresetsState}
						/>
					)}

					{attributes
						.filter((a) => a.group === name)
						.map((attribute) => {
							return (
								<AttributeControl key={attribute.key} attribute={attribute} />
							);
						})}
				</Box>
			</div>
		</div>
	);
}
